import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { AdvancePaymentCaptureTable } from 'src/app/models/tables/wallet/advance-payment-capture-table.model';
import { AdvancePaymentTableModal } from 'src/app/models/tables/wallet/advance-payment-table-modal.model';
import { AdvancePaymentAppliedModel } from 'src/app/models/wallet/advance-payment-applied.model';
import { CashReceiptModel } from 'src/app/models/wallet/cash-receipt.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdvancePaymentAppliedService {

  constructor(private _httpClient: HttpClient) { }

  createAdvancePaymentApplied(advancePaymentAppliedContract: AdvancePaymentAppliedModel): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advancePaymentApplied.CreateAdvancePaymentApplied}`,
      advancePaymentAppliedContract);
  }

  createSomeAdvancePaymentApplied(cashReceiptAdvancesIds: Array<number>, cashReceiptAppliedId: number): Observable<Array<AdvancePaymentAppliedModel>> {
    return this._httpClient.post<Array<AdvancePaymentAppliedModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advancePaymentApplied.CreateSomeAdvancePaymentApplied}/${cashReceiptAppliedId}`,
      cashReceiptAdvancesIds);
  }

  deleteAdvancePaymentApplied(cashReceiptAdvancesIds: Array<number>): Observable<Array<AdvancePaymentAppliedModel>> {
    return this._httpClient.put<Array<AdvancePaymentAppliedModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advancePaymentApplied.DeleteAdvancePaymentApplied}`,
      cashReceiptAdvancesIds);
  }

  getAppliedAdvancesByCashReceiptId(cashReceiptId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean): Observable<PagedResponseModel<AdvancePaymentCaptureTable>> {
    const params = new HttpParams().set('cashReceiptId', cashReceiptId).set('page', page).set('limit', limit)
      .set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.get<PagedResponseModel<AdvancePaymentCaptureTable>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advancePaymentApplied.GetAppliedAdvancesByCashReceiptIdAsync}`,
      { params: params }
    );
  }

  getAdvancesAvailable(cashReceiptId: number): Observable<Array<CashReceiptModel>> {
    return this._httpClient.get<Array<CashReceiptModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advancePaymentApplied.GetAdvancesAvailable}/${cashReceiptId}`);
  }

  getAdvancePaymentAppliedById(advancePaymentAppliedId: number): Observable<AdvancePaymentAppliedModel> {
    return this._httpClient.get<AdvancePaymentAppliedModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advancePaymentApplied.GetAdvancePaymentAppliedById}/${advancePaymentAppliedId}`);
  }

  getAppliedAdvances(cashReceiptId: number): Observable<Array<AdvancePaymentAppliedModel>> {
    return this._httpClient.get<Array<AdvancePaymentAppliedModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advancePaymentApplied.GetAppliedAdvances}/${cashReceiptId}`);
  }

  getColumnsForAdvancePaymentsModal(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advancePaymentApplied.GetColumnsForAdvancePaymentsModalAsync}`);
  }

  getColumnsForCaptureTable(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advancePaymentApplied.GetColumnsForCaptureTableAsync}`);
  }

  getListAdvancePaymentsForSelection(cashReceiptId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean): Observable<PagedResponseModel<AdvancePaymentTableModal>> {
    const params = new HttpParams().set('cashReceiptId', cashReceiptId).set('page', page).set('limit', limit)
      .set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.get<PagedResponseModel<AdvancePaymentTableModal>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advancePaymentApplied.GetListAdvancePaymentsForSelectionAsync}`,
      { params: params }
    );
  }

  updateAdvancePaymentApplied(advancePaymentAppliedContract: AdvancePaymentAppliedModel): Observable<Array<AdvancePaymentAppliedModel>> {
    return this._httpClient.put<Array<AdvancePaymentAppliedModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advancePaymentApplied.UpdateAdvancePaymentApplied}`,
      advancePaymentAppliedContract);
  }
}
